import { useState, useEffect } from "react";
import firebase from "firebase/compat/app";

import {
  Button,
  Drawer,
  message,
  Space,
  Typography,
} from "antd";
import { NavLink } from "react-router-dom";
import { CopyFilled } from "@ant-design/icons";
import RecentUsersMenu from "./RecentUsersMenu";

const logsetting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

const home = [
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path clipRule="evenodd" d="m11.31 1.77599c.186-.17728.433-.27617.69-.27617.2569 0 .504.09889.69.27617l8 7.61863 2.5 2.37988c.1923.183.304.4349.3105.7002.0066.2654-.0925.5225-.2755.7147-.183.1923-.4349.304-.7003.3106-.2653.0065-.5224-.0926-.7147-.2756l-.81-.7729v7.5476c0 .5304-.2107 1.0391-.5858 1.4141-.3751.3751-.8838.5858-1.4142.5858h-14.00001c-.53044 0-1.03915-.2107-1.41422-.5858-.37507-.375-.58578-.8837-.58578-1.4141v-7.5476l-.81.7719c-.19202.183-.44887.2822-.71405.2759-.26517-.0064-.516955-.1179-.699954-.3099-.183-.192-.282225-.4488-.275849-.714.006376-.2651.117832-.5169.309849-.6999l2.500004-2.38088 8.00001-7.61963zm-6.31001 8.77161v9.4515h4v-4.9998c0-.7956.31607-1.5586.87867-2.1212.56264-.5626 1.32564-.8786 2.12134-.8786.7956 0 1.5587.316 2.1213.8786s.8787 1.3256.8787 2.1212v4.9998h4v-9.4515l-7-6.66771-7.00001 6.66671zm8.00001 9.4515v-4.9998c0-.2652-.1054-.5195-.2929-.707-.1875-.1876-.4419-.2929-.7071-.2929s-.5196.1053-.7071.2929c-.1876.1875-.2929.4418-.2929.707v4.9998z" fill="#000" fillRule="evenodd" />
  </svg>
];



const setting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];

const ava = [
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 62 50" fill="none" preserveAspectRatio="xMidYMid meet" aria-hidden="true" role="img">
    <path d="M28.1309 0.450195L31.6561 49.5213H25.5088L20.2808 0.450195H28.1309Z" fill="currentColor"></path>
    <path d="M34.2675 0.450195L30.3071 49.5213H35.7854L41.9327 0.450195H34.2675Z" fill="currentColor"></path>
    <path d="M33.4962 37.6816H28.0669V48.1053H33.4962V37.6816Z" fill="currentColor"></path>
    <path d="M9.59099 43.4593C8.454 43.4593 7.81749 42.3729 7.81749 40.6185V27.3811C7.81749 26.235 8.60086 24.7575 9.8793 24.7575H12.6266V18.625H9.63993C3.60136 18.625 0 22.5685 0 28.4023V42.0633C0 47.2127 2.40999 49.9992 6.08753 49.9992C10.0262 49.9992 11.4842 45.7407 11.8106 43.481V40.8792L11.2666 40.9444C11.272 42.4436 10.5865 43.4593 9.59099 43.4593Z" fill="currentColor"></path>
    <path d="M9.49852 0C2.72553 0 0 5.16024 0 10.2607V16.4584H7.81749V8.62574C7.81749 7.25149 8.65527 6.56164 9.5801 6.56164C10.5049 6.56164 11.272 7.20803 11.272 8.44649V44.3563H11.9574L12.2186 49.4948H19.0895V9.7121C19.0895 3.82401 15.5534 0 9.49852 0Z" fill="currentColor"></path>
    <path d="M52.2482 43.4593C51.1167 43.4593 50.4802 42.3729 50.4802 40.6185V27.3811C50.4802 26.235 51.2636 24.7575 52.5366 24.7575H55.2893V18.625H52.3026C46.2641 18.625 42.6572 22.5685 42.6572 28.4023V42.0633C42.6572 47.2127 45.0672 49.9992 48.7448 49.9992C52.6889 49.9992 54.1468 45.7407 54.4733 43.481V40.8792L53.9292 40.9444C53.9292 42.4436 53.2438 43.4593 52.2482 43.4593Z" fill="currentColor"></path>
    <path d="M52.1602 0C45.3872 0 42.6345 5.16023 42.6345 10.2553V16.4584H50.4575V8.62574C50.4575 7.25149 51.2952 6.56164 52.2146 6.56164C53.134 6.56164 53.9065 7.20803 53.9065 8.44649V44.3563H54.592L54.8531 49.4948H61.7294V9.7121C61.7512 3.82401 58.2097 0 52.1602 0Z" fill="currentColor"></path>
  </svg>
];

function Header({
  placement,
  subName,
  onPress,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0)
  });

  const showDrawer = () => setVisible(true);
  const hideDrawer = () => setVisible(false);

  return (
    <>
      <div className="brand">
        <NavLink to="/">
          {ava}
          <span> Admin</span>
        </NavLink>
      </div>
    <div className="home-drwer" >
      <NavLink to="/">
        {home}
        </NavLink>
      </div>

      <div className="ant-page-header-heading">
        <span
          className="ant-page-header-heading-title"

        >
          {subName.replace("/", "")}
        </span>
      </div>

      <div style={{ flexGrow: 1 }}>&nbsp;</div>
      <RecentUsersMenu />
      <Button type="link" onClick={showDrawer}>
        {logsetting}
      </Button>
      <Button
        type="link"
        className="sidebar-toggler"
        onClick={() => onPress()}
      >
        {toggler}
      </Button>
      <Drawer
        className="settings-drawer"
        mask={true}
        width={360}
        onClose={hideDrawer}
        placement={placement}
        visible={visible}
      >
        <div layout="vertical">
          <div className="sidebar-color">
            <div className="fixed-nav mb-4">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button style={{ width: '100%' }} onClick={async () => {
                  const currentUser = firebase.auth().currentUser;
                  if (currentUser) {
                    // Firebase caches valid tokens, so this won't always be a network call
                    const token = await currentUser.getIdToken(/* forceRefresh */ false);
                    if (token) {
                      navigator.clipboard.writeText(token);
                      message.success('Copied Firebase token to clipboard!');
                    }
                  }
                }}>Copy Token</Button>
                <Button style={{ width: '100%' }} onClick={async () => {
                  const currentUser = firebase.auth().currentUser;
                  if (currentUser) {
                    // Firebase caches valid tokens, so this won't always be a network call
                    const token = currentUser.refreshToken;
                    if (token) {
                      navigator.clipboard.writeText(token);
                      message.success('Copied Firebase refresh token to clipboard!');
                    }
                  }
                }}>Copy Refresh Token</Button>
                <Button style={{ width: '100%' }} onClick={() => {
                  window.localStorage.clear();
                  firebase.auth().signOut()
                }}>Logout</Button>
              </Space>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default Header;
